import { useBasketSelector } from "store/basket";
import "./MiniBasket.scss";

interface IMiniBasketProps {
  handleClick: () => void;
}

export default function MiniBasket(props: IMiniBasketProps) {
  const { handleClick } = props;

  const { basketProductCount } = useBasketSelector();

  return (
    <button className="click-allowed minicart" onClick={handleClick}>
      {basketProductCount > 0 && <span className="ordernumber">{basketProductCount}</span>}
    </button>
  );
}
